module.exports = __webpack_public_path__ + "img/escritorio.3e5342b1.svg";